/* eslint-disable i18next/no-literal-string -- slot names not user facing text */
import { defineSlotRecipe } from '@chakra-ui/react';

export const segmentGroup = defineSlotRecipe({
  className: 'chakra-segment-group',
  slots: ['root', 'item', 'indicator'],
  base: {
    root: {
      '--segment-radius': 'radii.l2',
      borderRadius: 'full',
      border: '1px solid',
      borderColor: 'blue.500',
      bg: 'white',
      shadow: 'none',
    },

    item: {
      color: 'blue.500',
      borderRadius: '0',
      border: '1px solid',
      borderColor: 'transparent',
      height: 'unset',
      cursor: 'pointer',
      '&:has(input:focus-visible)': {
        focusRing: 'inside',
      },

      _before: {
        // content: '""',
        // position: 'absolute',
        bg: 'blue.fg',
        // transition: 'opacity 0.2s',
        height: '100%',
        top: 0,
      },

      '&[data-state=checked]': {
        bg: 'blue.500',
        color: 'white',
        borderRadius: 'none',
        shadow: 'none',
        cursor: 'auto',
        _hover: {
          bg: 'blue.500',
          shadow: 'none',
        },
      },

      _first: {
        borderLeftRadius: 'full',
      },
      _last: {
        borderRight: 'none',
        borderRightRadius: 'full',
      },

      _hover: {
        bg: 'transparent',
        shadow: '0px 4px 6px -1px rgba(0, 0, 0, 0.1), 0px 2px 4px -1px rgba(0, 0, 0, 0.06)',
      },
    },

    indicator: {
      shadow: 'none',
      pos: 'absolute',
      borderRadius: 'none',
      border: 'none',
    },
  },

  variants: {
    size: {
      xs: {
        item: {
          height: 'unset',
        },
      },
      sm: {
        item: {
          px: '2',
          height: 'unset',
        },
      },
      md: {
        item: {
          px: '3',
          height: 'unset',
        },
      },
      lg: {
        item: {
          height: 'unset',
        },
      },
    },
  },

  defaultVariants: {
    size: 'md',
  },
});
